import { EMAIL_BUILDER_COLOR_DIVIDER } from "../../schema/emailBuilderDesignColors";
import { BLOCK_PADDING, uid } from "../create-shared";
import type { EyebrowBlock, EyebrowTextTransform } from "../types";
import type { BlockDefinition } from "./types";

export const EYEBROW_DEFAULT_TEXT = 'Section label';

export const EYEBROW_FONT_WEIGHT = 700;

export const EYEBROW_FONT_SIZE = 11;

export const EYEBROW_TEXT_TRANSFORM =
  'uppercase' satisfies EyebrowTextTransform;

export const DEFAULT_EYEBROW_RULE_COLOR = EMAIL_BUILDER_COLOR_DIVIDER;

export function createEyebrowBlock(): EyebrowBlock {
  return {
    id: uid(),
    type: 'eyebrow',
    text: EYEBROW_DEFAULT_TEXT,
    rule: 'after',
    fontWeight: EYEBROW_FONT_WEIGHT,
    fontSize: EYEBROW_FONT_SIZE,
    textTransform: EYEBROW_TEXT_TRANSFORM,
    padding: { ...BLOCK_PADDING },
  };
}

export const eyebrowBlockDefinition: BlockDefinition = {
  type: 'eyebrow',
  label: 'Eyebrow',
  create: createEyebrowBlock,
};
